import API from "@/api";

function withVersionApi(params, fallback = "qt") {
    const p = params && typeof params === "object" ? { ...params } : {};
    const key = p._versionApi || fallback;
    delete p._versionApi;
    const api = API[key];
    if (!api) {
        throw new Error(`unknown client version api: ${key}`);
    }
    return { api, params: p };
}

export default {
    state: {
        qtList: [],
        qtListTotal: 0
    },
    getters: {
        qtList(state) {
            return state.qtList;
        },
        qtListTotal(state) {
            return state.qtListTotal;
        }
    },
    mutations: {
        SET_QT_LIST_DATAS(state, datas) {
            state.qtList = datas || [];
        },
        SET_QT_LIST_TOTAL(state, total) {
            state.qtListTotal = total || 0;
        }
    },
    actions: {
        async getQtList({commit}, params) {
            const { api, params: query } = withVersionApi(params);
            const ret = await api.queryList(query);
            commit('SET_QT_LIST_DATAS', ret && ret.data && ret.data.result);
            commit('SET_QT_LIST_TOTAL', ret && ret.data && ret.data.total);
        },
        async saveQt({}, params) {
            const { api, params: body } = withVersionApi(params);
            return await api.saveData(body);
        },
        async deleteQtData({}, params) {
            const { api, params: body } = withVersionApi(params);
            return await api.deleteDatas(body);
        },
        async findQtDataById({}, params) {
            const { api, params: body } = withVersionApi(params);
            return await api.findDataById(body);
        },
        async updateQtData({}, params) {
            const { api, params: body } = withVersionApi(params);
            return await api.updateData(body);
        },
        async updateQtStatus({}, params) {
            const { api, params: body } = withVersionApi(params);
            return await api.updateStatus(body);
        },
    }
};